import { AzureTableRowKeys } from '../../../common/common.table.interfaces'

export const WEBHOOKS_FLEXPORT_STATUS_OPTIONS: {value: string, display: string, description: string, selectable: boolean}[] = [
  {value: 'failed-retry', display: 'Failed Retry', description: 'The webhook event failed during Flexport communication and is trying to get it manually from the Flexport API.', selectable: false},
  {value: 'pending-load', display: 'Pending Load', description: 'The webhook event is waiting for data load processing.', selectable: true},
  {value: 'pending-notify', display: 'Pending Notify', description: 'The webhook event is waiting for notification processing.', selectable: true},
  {value: 'complete', display: 'Complete', description: 'The webhook event has completed loading and/or notification has been sent out.', selectable: true},
  {value: 'skipped-loading', display: 'Skipped Loading', description: 'The webhook event loading into Mission Control was skipped due to config. Will still attempt notify.', selectable: false},
  {value: 'skipped-notify', display: 'Skipped Notify', description: 'The webhook event notification was skipped due to config.', selectable: false},

]

export type WebhooksFlexportStatus = 'failed-retry' |'pending-load' | 'pending-notify' | 'complete' | 'skipped-loading' | 'skipped-notify'
/**
 * PartitionKey = event type eg. /shipment_leg#departed
 * RowKey = event id
 */
export interface WebhooksFlexportTableRow extends AzureTableRowKeys {
  type?: string
  status?: WebhooksFlexportStatus
  created_at?: string
  occurred_at?: string
  dataPath?: string
  salesforceRequest?: string
  loadedOn?: string
  notifiedOn?: string
}